var App = App || {};

App.Accessibility = (function ($) {
    'use strict';

    function init() {
        $(document).ready(function () {
            var $skipToOlb = $(".shared-accessibility .skip-to-olb");
            if (!$($skipToOlb.attr("data-bs-target")).length) {
                $skipToOlb.remove();
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Accessibility.init();
});